// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__LVy+h","content":"Preloader_content__1vMC2","percent":"Preloader_percent__a5KCw","lines":"Preloader_lines__Q-h+B","line":"Preloader_line__BiWpQ"};